module.exports = __webpack_public_path__ + "static/media/inf_19pog60p.241815b8.mp3";